import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-import-large.tsx
/**
* icon.24.import.large
*
* Attention, warning, exclamation mark
*
* Keywords: download, arrow, downward, save, inbox, receive, transfer, curved
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEwLjUgNGEuNS41IDAgMCAxIDAgMUg2YTEgMSAwIDAgMC0xIDF2MTJhMSAxIDAgMCAwIDEgMWgxMmExIDEgMCAwIDAgMS0xVjguNWEuNS41IDAgMCAxIDEgMFYxOGEyIDIgMCAwIDEtMiAySDZhMiAyIDAgMCAxLTItMlY2YTIgMiAwIDAgMSAyLTJ6bTkgMGEuNS41IDAgMCAxIDAgMUgxOWE2LjUgNi41IDAgMCAwLTYuNSA2LjV2Mi43OTNsMi42NDYtMi42NDdhLjUuNSAwIDAgMSAuNzA3LjcwN2wtMy41IDMuNWEuNS41IDAgMCAxLS43MDcgMGwtMy41LTMuNWEuNS41IDAgMCAxIC43MDgtLjcwN2wyLjY0NiAyLjY0NlYxMS41QTcuNSA3LjUgMCAwIDEgMTkgNHoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=21992-8433
*/
const Icon24ImportLarge = memo(function Icon24ImportLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M10.5 4a.5.5 0 0 1 0 1H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.5a.5.5 0 0 1 1 0V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm9 0a.5.5 0 0 1 0 1H19a6.5 6.5 0 0 0-6.5 6.5v2.793l2.646-2.647a.5.5 0 0 1 .707.707l-3.5 3.5a.5.5 0 0 1-.707 0l-3.5-3.5a.5.5 0 0 1 .708-.707l2.646 2.646V11.5A7.5 7.5 0 0 1 19 4z"
		})
	});
});
//#endregion
export { Icon24ImportLarge };

//# sourceMappingURL=icon-24-import-large.js.map